export default {
	token: '', // 微信授权之后返回的凭证
	client: 1, // 客户端类型 微信:0; H5:1; App:2
	searchName: [], // 寺庙列表保存最新搜索列表
	templeName: '', // 搜索寺庙的关键字
	ledCode: '', // 下单选择灯位列表， 以','(英文逗号)隔开
  	imgBaseUrl: 'http://qn.fayuanhui.cn/default.png',
	musicSrc:'',
	musicTime:'0'
}



// WEBPACK FOOTER //
// ./src/store/state.js